<template>
  <filter-tab-component :active="getFiltersTabIsActive" @close="closeTab">
    <div
      class="flex flex-col space-y-6 text-ontick-carbon-900 dark:text-gray-300"
    >
      <h3 class="text-2xl font-bold">Filtros</h3>
      <collapse-group-component
        :data="filters.plano"
        @selected="(val) => (values.plano = val)"
      />
      <collapse-group-component
        :data="filters.desenvolvedor"
        @selected="(val) => (values.desenvolvedor = val)"
      />
      <!-- <collapse-group-component
        :data="filters.tipo"
        @selected="(val) => (values.tipo = val)"
      /> -->
      <!-- <collapse-group-component
        :data="filters.preço"
        @selected="(val) => (values.preço = val)"
      /> -->
    </div>
  </filter-tab-component>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CollapseTransitionGroupComponent from "../../../shared/components/expanded/collapse.transition-group.component.vue";
import CollapseGroupComponent from "../../../shared/components/filters/collapse-group.component.vue";
import filterTabComponent from "../../../shared/components/filters/filter-tab.component.vue";
export default {
  components: {
    filterTabComponent,
    CollapseTransitionGroupComponent,
    CollapseGroupComponent,
  },
  data() {
    return {
      show: false,
      filters: {
        plano: {
          group_name: "Plano",
          options: [
            { name: "Basic", value: "BASIC" },
            { name: "Pro", value: "PRO" },
            { name: "Unlimited", value: "UNLIMITED" },
            { name: "Assinatura", value: "SUBSCRIPTION" },
          ],
        },
        desenvolvedor: {
          group_name: "Desenvolvedor",
          options: [
            { name: "OnTick", value: "OnTick" },
            { name: "Parceiros", value: "Parceiros" },
          ],
        },
        // tipo: {
        //   group_name: "Tipo",
        //   options: [
        //     { name: "Integrações", value: "Integrações" },
        //     { name: "Estratégias", value: "Estratégias" },
        //     { name: "Outros", value: "Outros" },
        //   ],
        // },
        preço: {
          group_name: "Preço",
          options: [
            { name: "Gratuito", value: "Gratuito" },
            { name: "Pago", value: "Pago" },
          ],
        },
      },
      values: {
        plano: [],
        desenvolvedor: [],
        preço: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      getFiltersTabIsActive: "partners/getFiltersTabIsActive",
      getActiveFilters: "partners/getActiveFilters",
    }),
  },
  methods: {
    ...mapActions({
      setFiltersTabIsActive: "partners/setFiltersTabIsActive",
      setActiveFilters: "partners/setActiveFilters",
    }),
    closeTab() {
      this.setFiltersTabIsActive(false);
    },
  },
  watch: {
    values: {
      deep: true,
      handler(val) {
        this.setActiveFilters(val);
      },
    },
  },
};
</script>

<style></style>
